export default {
  striptags: {
    simple: '<span><strong><em><u><del><br>',
  },
};
